import React, { Component } from "react";
import axios from 'axios';
import api from '../api';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '0',
  	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem'
  }
});


class Parking extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {work_order_parking:{work_order:{user_id:''}},snackbar:{open:false}, loading: true}
  	}

    async componentDidMount() {
    	var work_order_id = this.props.id
    	await this.getWorkOrderParking(work_order_id)
    	this.setState({loading: false})
    }

   	async getWorkOrderParking(id){
		const token = localStorage.getItem('userToken')
		return await axios
	     .get(api.work_order_parking().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		res.data.start_date = res.data.start_date
	      		res.data.end_date = res.data.end_date
	      		var work_order_parking = res.data
	      		this.setState({work_order_parking: work_order_parking, loading: false})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    handleChange = (e) =>{
    	var work_order_parking = this.state.work_order_parking
    	work_order_parking[e.target.name] = e.target.value
    	this.setState({work_order_parking: work_order_parking})
    }

   handleSubmit = () => {
	    var formData = new FormData();
	    var url = api.work_order_parking().post();
	    formData.set("work_order_parking[work_order_id]", this.props.id);
	    formData.set("work_order_parking[start_date]", (this.state.work_order_parking.start_date) ? this.state.work_order_parking.start_date : '');
	    formData.set("work_order_parking[end_date]", (this.state.work_order_parking.end_date) ? this.state.work_order_parking.end_date : '');
	    formData.set("work_order_parking[description]", (this.state.work_order_parking.description) ? this.state.work_order_parking.description : '');
	    formData.set("work_order_parking[comments]", (this.state.work_order_parking.comments) ? this.state.work_order_parking.comments : '');

	    if (this.state.work_order_parking.id !== undefined) {
	    	url = api.work_order_parking().patch(this.props.id)
		    formData.set("work_order_parking[id]", this.state.work_order_parking.id);
		    formData.set("_method", 'PATCH');
	    }
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(url,
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
	      		var snackbar = {open: true, success_message: 'Cochera cargada con éxito', severity: 'success'}
		  		self.setState({ snackbar: snackbar})

	      })
	      .catch(function (error) {
//	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
	      		var error_message = ''
	      		var errors = error.response.data
				if (errors.errors){
					if (errors.status_code !== 404){
					  var keys = Object.keys(errors.errors); 
					  for(var i = 0; i < keys.length; i++) {   
					    var key = (keys[i]) ; 
					    var key_errors = errors.errors[key]
					    key_errors.map((val,idx)=>{
					      error_message = error_message.concat(val).concat(' ')
					    })
					  }
					} else {
				      error_message = error_message.concat(error.message).concat(' ')
					}
				}

	      		var snackbar = {open: true, success_message: error_message, severity: 'warning'}
		  		self.setState({ snackbar: snackbar})
	    })
    }

    handleSnackbar = () => {
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }

	render() {
		var work_order_parking = this.state.work_order_parking
		const classes = this.props.classes;
		return (
			<React.Fragment>
				<Snackbar open={this.state.snackbar.open} autoHideDuration={10000} onClose={this.handleSnackbar}>
					<Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
					  {this.state.snackbar.success_message}
					</Alert>
				</Snackbar>
				{(this.state.loading)
					?
					''
					:
					<React.Fragment>
						<div className="row mt-2"> 
							<TextField
								id="start_date"
								value={work_order_parking.start_date}
								onChange={this.handleChange}
								type="date"
								name="start_date"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha desde</Typography></InputAdornment>,
								}}
							/>		
							<TextField
								id="end_date"
								value={work_order_parking.end_date}
								onChange={this.handleChange}
								type="date"
								name="end_date"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha hasta</Typography></InputAdornment>,
								}}
							/>	
							<TextField
								id="description"
								name="description"
								value={work_order_parking.description}
								onChange={this.handleChange}
								type="text"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Motivo</Typography></InputAdornment>,
							        style:{fontSize: '0.75rem'}
								}}
							/>
                        </div>
		
						<div className="row mt-2">
							<TextField
								id="comments"
								value={work_order_parking.comments}
								onChange={this.handleChange}
								type="text"
								fullWidth
								name="comments"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Comentarios</Typography></InputAdornment>,
								}}
							/>	
						</div>	
						<div className="row mt-2">
							<Button className="mt-1" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e)=>{this.handleSubmit(e)}}>{(this.state.work_order_parking.id) ? 'Guardar' : 'Cargar'}</Button>
						</div>
					</React.Fragment>
				}
			</React.Fragment>
		)
	}

}

export default withStyles(useStyles)(Parking);

